import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import EventsPage from './pages/EventsPage';
import EventDetailsPage from './pages/EventDetailsPage';
import CheckoutPage from './pages/CheckoutPage';
// import CheckoutPageWithWebSocket from './pages/CheckoutPageWithWebSocket';
// import MockPaymentPage from './pages/MockPaymentPage';
import RegistrationPage from './pages/RegistrationPage';
import BillingPage from './pages/BillingPage';
import RegistrationSuccessPage from './pages/RegistrationSuccessPage';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import PaymentPage from './pages/PaymentPage';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import ReceiptPage from './pages/ReceiptPage';
import CIF from './pages/CIF';
import TournamentRulesPage from './pages/TournamentRulesPage';
import LiabilityWaiversPage from './pages/LiabilityWaiversPage';
import { PaymentProvider } from './context/PaymentContext';

function App() {
  return (
    <PaymentProvider>
      <Router basename={process.env.PUBLIC_URL || '/'}>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<LandingPage />} />

            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:eventId" element={<EventDetailsPage />} />
            
            {/* Checkout Routes */}
            {/* <Route path="/checkout/:eventId" element={<CheckoutPageWithWebSocket />} /> */}
            <Route path="/checkout/:eventId" element={<CheckoutPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            {/* <Route path="/mock-payment" element={<MockPaymentPage />} /> */}
            
            {/* Champions Classic Registration Routes */}
            <Route path="/register" element={<RegistrationPage />} />
            <Route path="/register/champions-classic" element={<RegistrationPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/registration-success" element={<RegistrationSuccessPage />} />
            <Route path="/payment-callback" element={<PaymentCallbackPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            
            {/* Receipt Page */}
            <Route path="/receipt/:confirmationNumber" element={<ReceiptPage />} />

            {/* Policy Pages */}
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/refund" element={<RefundPolicyPage />} />
            <Route path="/cif" element={<CIF />} />
            <Route path="/tournament-rules" element={<TournamentRulesPage />} />
            <Route path="/liability-waivers" element={<LiabilityWaiversPage />} />
          </Routes>
        </div>
      </Router>
    </PaymentProvider>
  );
}

export default App;